import { Button, Card, Text } from '@kanda-libs/ks-design-library';
import useHelpModal from 'components/HelpModal/useHelpModal';
import type { FunctionComponent } from 'react';
import { CLASS_NAMES } from './constants';

const ContactBanner: FunctionComponent = function () {
  const { showHelpModal } = useHelpModal();

  return (
    <Card className={CLASS_NAMES.wrapper}>
      <div className={CLASS_NAMES.innerWrapper}>
        <div>
          <Text text="Customer support" className={CLASS_NAMES.title} />
          <Text
            text="Have a question for us? Get in touch"
            className={CLASS_NAMES.subTitle}
          />
        </div>
        <div className={CLASS_NAMES.ctas}>
          <Button.Text
            id="footer-chat"
            size={40}
            label="Chat with us"
            variant="outline-primary"
            onClick={() => {
              showHelpModal();
            }}
          />
        </div>
      </div>
    </Card>
  );
};

export default ContactBanner;
